import { render } from "./TaskStatus.vue?vue&type=template&id=24de02ba"
import script from "./TaskStatus.vue?vue&type=script&lang=js"
export * from "./TaskStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__